import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import './AgendaPage.css'

function AgendaPage() {
    return <div className="AgendaPage">
        <Navbar />
        <div className="agenda-page">
            <div className="agenda-container">
                <h1 className="agenda-title">Agenda</h1>
                <p className="agenda-intro">
                    Digital twins are reshaping how cities, infrastructure, and buildings are designed, operated, and governed. 
                    This symposium brings together leading AEC/FM companies, asset owners, researchers, and innovators to showcase 
                    real-world applications and explore what's next for digital twins in urban environments. The program highlights 
                    urban digital twins for smarter built environments, the role and use of AI and large language models to create, 
                    integrate, and operate digital twins, and the challenges of scaling these systems at the intersection of cybersecurity, 
                    data governance, and best practices.
                </p>
                
                <div className="agenda-table">
                    <div className="agenda-row header">
                        <div className="agenda-time">Time</div>
                        <div className="agenda-item">Agenda Item</div>
                        <div className="agenda-people">Key People</div>
                    </div>
                    
                    <div className="agenda-row">
                        <div className="agenda-time">8:00-8:30 AM</div>
                        <div className="agenda-item"><strong>Breakfast and Networking</strong></div>
                        <div className="agenda-people"></div>
                    </div>
                    
                    <div className="agenda-row">
                        <div className="agenda-time">8:30-9:00 AM</div>
                        <div className="agenda-item">
                            <strong>Welcome</strong>
                            <br />
                            Opening remarks
                        </div>
                        <div className="agenda-people">
                            <a href="/speakers#semiha-ergan" className="agenda-link">Semiha Ergan, NYU</a><br />
                            <a href="/speakers#mario-berges" className="agenda-link">Mario Berges, CMU</a><br />
                            <a href="/speakers#de-pablo" className="agenda-link">Juan de Pablo, Dean, NYU Tandon School of Engineering</a><br />
                            <a href="/speakers#gary-fedder" className="agenda-link">Gary Fedder, CMU</a>
                        </div>
                    </div>
                    
                    <div className="agenda-row">
                        <div className="agenda-time">9:00-9:50 AM</div>
                        <div className="agenda-item">
                            <strong>Academic Keynote and Q/A</strong>
                            <br />
                            <em>Design, Connect, Evolve: How Digital Twins Will Redefine the Built Environment</em>
                            <br />
                            <span className="agenda-abstract">The built environment is undergoing a fundamental transformation. Digital twins have the opportunity to become a cornerstone of how buildings and campuses are planned, operated, and evolved over time. Yet realizing this potential requires more than technology. It demands a deliberate strategy, a structured data foundation, and a clear vision for how digital twins can create value across the building lifecycle.</span>
                            <br /><br />
                            <span className="agenda-abstract">This talk presents a framework for digital twin planning that connects the promise of the technology to practical implementation. The framework recognizes that the power of a digital twin depends on the quality and structure of the underlying building models that feed it. Drawing on advances in Building Information Modeling and structured data standards, the discussion explores how organizations can build the digital foundation necessary to support connected, evolving twin environments.</span>
                            <br /><br />
                            <span className="agenda-abstract">These concepts are brought to life through Penn State&apos;s campus digital twin initiative, an ambitious effort to develop a living digital representation of the university&apos;s built environment, illustrating how a phased planning approach grounded in structured building models and AI-driven analytics can scale from individual facilities to a campus-wide system.</span>
                        </div>
                        <div className="agenda-people">
                            <a href="/speakers#john-messner" className="agenda-link">John Messner, Penn State University</a>
                        </div>
                    </div>
                    
                    <div className="agenda-row highlight">
                        <div className="agenda-time">10:00-11:30 AM</div>
                        <div className="agenda-item">
                            <strong>Panel 1: AI-Powered Digital Twins: Design, Integrate, and Operate at Scale</strong>
                            <br />
                            Harnessing the power of AI to make digital twins operationally feasible and effective
                        </div>
                        <div className="agenda-people">
                            <div><strong>Panelists:</strong></div>
                            <a href="/speakers#dustin-basler" className="agenda-link">Dustin Basler, Siemens</a><br />
                            <a href="/speakers#bianca-howard" className="agenda-link">Bianca Howard, Columbia</a><br />
                            <a href="/speakers#jorge-ortiz" className="agenda-link">Jorge Ortiz, Rutgers</a><br />
                            <strong>Moderator:</strong> <a href="/speakers#mario-berges" className="agenda-link">Mario Berges, CMU</a>
                        </div>
                    </div>
                    
                    <div className="agenda-row">
                        <div className="agenda-time">11:30 AM-12:30 PM</div>
                        <div className="agenda-item"><strong>Lunch &amp; Poster Session</strong></div>
                        <div className="agenda-people"></div>
                    </div>
                    
                    <div className="agenda-row">
                        <div className="agenda-time">12:30-1:15 PM</div>
                        <div className="agenda-item">
                            <strong>Industry Keynote and Q/A</strong>
                            <br />
                            <em>The Symbiosis of Simulation and Intelligence: Digital Twins in an Automated Future</em>
                            <br />
                            <span className="agenda-abstract">The next frontier of industrial automation demands a shift from passive digital replicas to proactive, autonomous "computational twins." As the industry scales smart infrastructure, the convergence of artificial intelligence and physics-based modeling has become essential. This keynote explores the critical symbiosis of these two approaches—grounding rapid AI decision-makers in the reliable physics of traditional models to unlock safe, predictable, and optimized automated interventions in the physical world.</span>
                        </div>
                        <div className="agenda-people">
                            <a href="/speakers#john-sipple" className="agenda-link">John Sipple, Google</a>
                        </div>
                    </div>
                    
                    <div className="agenda-row highlight">
                        <div className="agenda-time">1:15-2:15 PM</div>
                        <div className="agenda-item">
                            <strong>Panel 2: Urban Digital Twins</strong>
                            <br />
                            Models of infrastructure/buildings and cities to design better built environments, to take advantage of emerging technologies
                        </div>
                        <div className="agenda-people">
                            <div><strong>Panelists:</strong></div>
                            <a href="/speakers#sharon-di" className="agenda-link">Sharon Di, Columbia University</a><br />
                            <a href="/speakers#corey-harper" className="agenda-link">Corey Harper, CMU</a><br />
                            <a href="/speakers#kaan-ozbay" className="agenda-link">Kaan Ozbay, NYU C2SMART Center</a><br />
                            <strong>Moderator:</strong> <a href="/speakers#gary-fedder" className="agenda-link">Gary Fedder, CMU</a>
                        </div>
                    </div>
                    
                    <div className="agenda-row">
                        <div className="agenda-time">2:15-2:30 PM</div>
                        <div className="agenda-item"><strong>Coffee break</strong></div>
                        <div className="agenda-people"></div>
                    </div>
                    
                    <div className="agenda-row">
                        <div className="agenda-time">2:30-3:15 PM</div>
                        <div className="agenda-item">
                            <strong>Industry Keynote and Q/A</strong>
                            <br />
                            <em>No More Pools or Ponds. They are nice, but AEC needs a Lake.</em>
                            <br />
                            <span className="agenda-abstract">AEC data is currently trapped in "ponds"—proprietary silos and static files where design intent goes to die. But you can't build a Digital Twin on a puddle. To move the needle, we must shift from closed applications to a Design Data Lakehouse. This session explores how merging the flexibility of a "lake" with the structure of a "house" allows design data to flow freely. By breaking down digital fences, we enable AI to transform fragmented BIM fragments into a unified, living asset.</span>
                        </div>
                        <div className="agenda-people">
                            <a href="/speakers#greg-schleusner" className="agenda-link">Greg Schleusner, HOK</a>
                        </div>
                    </div>
                    
                    <div className="agenda-row highlight">
                        <div className="agenda-time">3:15-4:15 PM</div>
                        <div className="agenda-item">
                            <strong>Panel 3: Pitfalls to Practice: Lessons in DT Success</strong>
                            <br />
                            Cybersecurity, data governance, and other practical considerations in adopting digital twins for large scale operations
                        </div>
                        <div className="agenda-people">
                            <div><strong>Panelists:</strong></div>
                            <a href="/speakers#ayse-polat" className="agenda-link">Ayse Polat, Turner Construction</a><br />
                            <a href="/speakers#jan-reinhardt" className="agenda-link">Jan Reinhardt, BIMForum, Adept</a><br />
                            <a href="/speakers#mike-dituro" className="agenda-link">Mike Dituro, JPMorgan</a><br />
                            <a href="/speakers#gus-maimis" className="agenda-link">Gus Maimis, STV Construction, Inc.</a><br />
                            <strong>Moderator:</strong> <a href="/speakers#aysun-sarikardasoglu" className="agenda-link">Aysun Sarikardasoglu, JPMorgan</a>
                        </div>
                    </div>
                    
                    <div className="agenda-row">
                        <div className="agenda-time">4:15-4:30 PM</div>
                        <div className="agenda-item">
                            <strong>Closing remarks, key takeaways</strong>
                        </div>
                        <div className="agenda-people">
                            <a href="/speakers#semiha-ergan" className="agenda-link">Semiha Ergan, NYU</a><br />
                            <a href="/speakers#mario-berges" className="agenda-link">Mario Berges, CMU</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>;
}

export default AgendaPage;
